var module = angular.module('octopusApp.environments');

module.directive('tentaclePassiveEndpoint', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      endpoint: '='
    },
    templateUrl: 'areas/environments/views/endpoints/tentacle_passive_endpoint.html',
    controller: function($scope, octopusRepository, busy) {
      var isLoading = $scope.isLoading = busy.create();

      $scope.view = {};
      $scope.view.tentacleUseProxy = !!$scope.endpoint.ProxyId;

      isLoading.promise(octopusRepository.CertificateConfiguration.getOctopusCertificate().then(function (certificate) {
        isLoading.promise(octopusRepository.Proxies.list().then(function (proxies) {
          $scope.serverThumbprint = certificate.Thumbprint;
          $scope.proxies = proxies.Items;
        }));
      }));

      $scope.useProxyChanged = function(){
        if(!$scope.view.tentacleUseProxy){
          $scope.endpoint.ProxyId = null;
        }
      };

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/tentacle_passive_endpoint.js
// module id = 7332484757026243
// module chunks = 1